/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TypingInputs */

const en_typing = /** @type {(inputs: TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`typing...`)
};

const id_typing = /** @type {(inputs: TypingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mengetik...`)
};

/** @type {(inputs: TypingInputs) => LocalizedString} */
const es_typing = en_typing;

/** @type {(inputs: TypingInputs) => LocalizedString} */
const fr_typing = en_typing;

/** @type {(inputs: TypingInputs) => LocalizedString} */
const de_typing = en_typing;

/** @type {(inputs: TypingInputs) => LocalizedString} */
const ja_typing = en_typing;

/** @type {(inputs: TypingInputs) => LocalizedString} */
const zh_typing = en_typing;

/** @type {(inputs: TypingInputs) => LocalizedString} */
const ar_typing = en_typing;

/** @type {(inputs: TypingInputs) => LocalizedString} */
const it_typing = en_typing;

/** @type {(inputs: TypingInputs) => LocalizedString} */
const ru_typing = en_typing;

/** @type {(inputs: TypingInputs) => LocalizedString} */
const pt_typing = en_typing;

/** @type {(inputs: TypingInputs) => LocalizedString} */
const ko_typing = en_typing;

/**
* | output |
* | --- |
* | "typing..." |
*
* @param {TypingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const typing = /** @type {((inputs?: TypingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TypingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_typing(inputs)
	if (locale === "es") return es_typing(inputs)
	if (locale === "fr") return fr_typing(inputs)
	if (locale === "de") return de_typing(inputs)
	if (locale === "ja") return ja_typing(inputs)
	if (locale === "zh") return zh_typing(inputs)
	if (locale === "ar") return ar_typing(inputs)
	if (locale === "id") return id_typing(inputs)
	if (locale === "it") return it_typing(inputs)
	if (locale === "ru") return ru_typing(inputs)
	if (locale === "pt") return pt_typing(inputs)
	return ko_typing(inputs)
});